
import LikeTag from "../../../assets/outline/LikeTag.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LikeTagIcon({ className, dataTestid = "LikeTagIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <LikeTag data-testid={dataTestid} className={classes} {...rest} />
  );
}
